<!-- 行情列表 -->
<template>
  <div class="quotation-box">
    <!-- tab头 -->
    <tab-list-header :list="tabList" :cur-index="curIndex" @clickTab="clickTab" />
    <!-- 列表内容 -->
    <quotation-common-list
      :list-type="curTab.value"
      :header-list="headerList"
      :dataSource="getData(curTab.value)"
      :detail-info="detailInfo"
      :more-text="moreText"
      :click-track="'xpzy.pzy.gdjdzf.click'">
      <template slot="top-extra">
        <div v-if="curRowType==='stage-rise-row' && detailInfo && detailInfo.isUpdating"
          class="update row"
          @click="$goFundApp">
          <div>更新中</div>
          <img :src="UPDATE_ICON" />
        </div>
      </template>
      <template slot="list-item" slot-scope="{item}">
        <!-- 阶段涨跌幅 -->
        <component
          :is="curRowType"
          :item="item"
          :fund-type="fundType"
          :is-show-smart-invest="isShowSmartInvest" />
      </template>
    </quotation-common-list>
  </div>
</template>

<script>
import TabListHeader from '@/components/chart/TabListHeader.vue';
import CONFIG from '@/configs/default';
import QuotationCommonList from './QuotationCommonList.vue';
import StageRiseRow from './StageRiseRow.vue';
import HistoryNetRow from './HistoryNetRow.vue';
import FixedInvestRow from './FixedInvestRow.vue';

export default {
  name: 'fund-market-quotation',

  components: {
    TabListHeader,
    QuotationCommonList,
    StageRiseRow,
    HistoryNetRow,
    FixedInvestRow,
  },

  props: {
    fundType: {
      type: String,
      default: '',
    },
    fundCode: {
      type: String,
      default: '',
    },
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      curIndex: 0,
      UPDATE_ICON: 'https://j5.dfcfw.com/sc/image/202111/20211112025431.png',
    };
  },

  computed: {
    tabList() {
      return CONFIG.quotationTabList[this.fundType] || CONFIG.quotationTabList.default;
    },
    curTab() {
      return this.tabList[this.curIndex];
    },
    isShowSmartInvest() {
      return this.detailInfo?.fixedInvestList[0]?.isShowSmartInvest || false;
    },
    headerList() {
      const list = CONFIG.quotationListHeader[this.curTab?.value] || [];
      if (this.curTab?.value === 'fixedProfit') { // 定投收益表头特殊处理
        const bestFixedInvestStrategy = this.detailInfo?.bestFixedInvestStrategy || '--';
        const tmpList = [ // 定投收益
          {
            name: '周期',
            style: {
              flex: 1,
              justifyContent: 'flex-start',
            },
          },
          {
            name: '普通定投',
            style: {
              flex: 1,
              justifyContent: 'center',
            },
          },
          {
            name: '智能定投',
            style: {
              flex: 1,
              justifyContent: 'flex-end',
            },
            showTip: !this.$isEmpty(bestFixedInvestStrategy),
            tipModalType: 'smart-fixed',
          },
        ];
        if (this.isShowSmartInvest) return tmpList;
        tmpList[1].style = {
          flex: 1,
          justifyContent: 'flex-end',
        };
        return [tmpList[0], tmpList[1]];
      }
      return list;
    },
    dataList() {
      const detailKeyMap = {
        stageRise: 'stageRiseList',
      };
      const infoKey = detailKeyMap[this.curTab.value];
      return this.$isEmpty(this.detailInfo) ? [] : this.detailInfo[infoKey]?.slice(0, 5) || [];
    },
    moreText() {
      const textMap = {
        stageRise: '更多阶段涨幅',
        historyNetValue: '更多历史净值',
        fixedProfit: this.isShowSmartInvest ? '定投计算器算收益' : '',
        annualizationOf7D: '更多历史收益',
      };
      return textMap[this.curTab?.value] || '';
    },
    curRowType() {
      const rowCompMap = {
        stageRise: 'stage-rise-row',
        historyNetValue: 'history-net-row',
        fixedProfit: 'fixed-invest-row',
        annualizationOf7D: 'history-net-row',
      };
      return rowCompMap[this.curTab.value] || '';
    },
  },

  methods: {
    clickTab(index) {
      this.curIndex = index;
    },

    // 获取当前tab数据
    async getData(tabValue) {
      let historyRes = [];
      switch (tabValue) {
        case 'stageRise': // 阶段涨幅
          return this.$isEmpty(this.detailInfo) ? []
            : this.detailInfo?.stageRiseList?.slice(0, 5) || [];
        case 'historyNetValue': // 历史净值
          historyRes = await this.getHistoryRes();
          return historyRes;
        case 'fixedProfit':
          return this.$isEmpty(this.detailInfo) ? []
            : this.detailInfo?.fixedInvestList || [];
        case 'annualizationOf7D': // 历史净值
          historyRes = await this.getHistoryRes();
          return historyRes;
        default: return [];
      }
    },

    // 获取历史净值
    async getHistoryRes() {
      const cacheKey = `ttjj-history-net-${this.fundCode}`;
      const cacheRes = JSON.parse(localStorage.getItem(cacheKey)) || {};
      const curTime = new Date().getTime();
      const lastTime = cacheRes?.lastTime || 0;
      let historyRes = cacheRes?.list || [];
      if (curTime - lastTime > 3 * 60 * 60 * 1000 // 缓存过期
        || this.$isEmpty(historyRes)) {
        historyRes = await this.$http.useRequests('FundComApi.getPublicFundDiagramPageSort', {
          FCODE: this.fundCode,
          pageIndex: 1,
          pageSize: 5,
        }).catch((err) => { console.log('getHistoryRes ERR', err); });
        localStorage.setItem(cacheKey, JSON.stringify({
          list: historyRes,
          lastTime: curTime,
        }));
      }
      return historyRes;
    },
  },

};
</script>

<style lang="less" scoped>
.quotation-box {
  width: 100%;
  padding: 32px 24px;
  background-color: #FFFFFF;
  border-radius: 12px;
  box-sizing: border-box;
  margin-top: 24px;
  .update {
    justify-content: flex-end;
    font-size: 24px;
    color: #FF4400;
    img {
      width: 26px;
      height: 26px;
      margin-left: 8px;
    }
  }
  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}
</style>
